import { ApiClient } from '../../common/services/apiClient';
import type {
  BajaBody,
  BajaRespuesta,
  CerrarSesionesBody,
  CerrarSesionesRespuesta,
} from '../../negocio/negocio.types';

/**
 * Sesiones y baja por rotación (Consulta CM, fase 0). Sólo superadmin y admin.
 * Un 409 `CONFIRMAR_CUENTA_COMPARTIDA` llega como `Error` con `codigo`
 * (`ApiClient`): la pantalla pide la confirmación y reintenta.
 */
export class SesionesService {
  static cerrarSesiones(userId: string, body: CerrarSesionesBody): Promise<CerrarSesionesRespuesta> {
    return ApiClient.post<CerrarSesionesRespuesta>(`/users/${encodeURIComponent(userId)}/cerrar-sesiones`, body);
  }

  static baja(userId: string, body: BajaBody): Promise<BajaRespuesta> {
    return ApiClient.post<BajaRespuesta>(`/users/${encodeURIComponent(userId)}/baja`, body);
  }
}
